<template>
  <div class="FooterGreyLeft" role="contentinfo" :data-theme="this.$store.state.chosenBrand">
    <div class="sokal-modern-styles footer-dealer-name-add-on sokal-py-4 sokal-pb-0">
      <div class="sokal-container">
        <div class="row">
          <div class="col-xs-12">
            <div class="sokal-flex sokal-items-center sokal-justify-between sokal-flex-col sokal-md-flex-row sokal-gap">
              <h2 class="dealer-name primary-dark-color weight-semibold">Hometown Dealer</h2>
              <div class="contact-cta-block sokal-flex sokal-gap sokal-flex-wrap sokal-items-center">
                <a href="/contact" class="add-on-contact-btn sokal-flex sokal-gap sokal-items-center sokal-justify-between">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M4 14V11C4 8.87827 4.84285 6.84344 6.34315 5.34315C7.84344 3.84285 9.87827 3 12 3C14.1217 3 16.1566 3.84285 17.6569 5.34315C19.1571 6.84344 20 8.87827 20 11V14M18 19C18 20.657 15.314 22 12 22" stroke="#066FEF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M4 14C4 13.4696 4.21071 12.9609 4.58579 12.5858C4.96086 12.2107 5.46957 12 6 12H7C7.53043 12 8.03914 12.2107 8.41421 12.5858C8.78929 12.9609 9 13.4696 9 14V17C9 17.5304 8.78929 18.0391 8.41421 18.4142C8.03914 18.7893 7.53043 19 7 19H6C5.46957 19 4.96086 18.7893 4.58579 18.4142C4.21071 18.0391 4 17.5304 4 17V14ZM15 14C15 13.4696 15.2107 12.9609 15.5858 12.5858C15.9609 12.2107 16.4696 12 17 12H18C18.5304 12 19.0391 12.2107 19.4142 12.5858C19.7893 12.9609 20 13.4696 20 14V17C20 17.5304 19.7893 18.0391 19.4142 18.4142C19.0391 18.7893 18.5304 19 18 19H17C16.4696 19 15.9609 18.7893 15.5858 18.4142C15.2107 18.0391 15 17.5304 15 17V14Z" stroke="#066FEF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span class="add-on-contact-btn-text weight-bold">Contact Us</span>
                </a>
                <a href="/directions" class="add-on-contact-btn sokal-flex sokal-gap sokal-items-center sokal-justify-between">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M21.4613 4.65854C21.3714 4.58854 21.2668 4.53992 21.1554 4.51636C21.0439 4.49281 20.9286 4.49494 20.8181 4.5226L15.0872 5.9551L9.33563 3.07885C9.17537 2.99892 8.99181 2.97897 8.81812 3.0226L2.81812 4.5226C2.65587 4.56316 2.51183 4.65679 2.40889 4.7886C2.30595 4.92042 2.25003 5.08286 2.25 5.2501V18.7501C2.25002 18.8641 2.27601 18.9765 2.32599 19.0789C2.37598 19.1814 2.44864 19.271 2.53847 19.3412C2.62831 19.4113 2.73294 19.46 2.84442 19.4837C2.95591 19.5073 3.07131 19.5052 3.18187 19.4776L8.91281 18.0451L14.6644 20.9214C14.7688 20.9728 14.8836 20.9998 15 21.0001C15.0613 21.0001 15.1224 20.9925 15.1819 20.9776L21.1819 19.4776C21.3441 19.437 21.4882 19.3434 21.5911 19.2116C21.694 19.0798 21.75 18.9174 21.75 18.7501V5.2501C21.75 5.13603 21.724 5.02346 21.674 4.92095C21.624 4.81844 21.5512 4.7287 21.4613 4.65854ZM9.75 4.96323L14.25 7.21323V19.037L9.75 16.787V4.96323ZM3.75 5.83604L8.25 4.71104V16.6642L3.75 17.7892V5.83604ZM20.25 18.1642L15.75 19.2892V7.33604L20.25 6.21104V18.1642Z" fill="#066FEF"/>
                  </svg>
                  <span class="add-on-contact-btn-text weight-bold">Get Directions</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="footer-line-divide"></div>
      <div class="row">
        <div class="col-xs-12">
          <div class="FooterGreyLeftMenu">
            <li role="menuitem">
              <a href="#" target="" title="New">New</a>
            </li>
            <li role="menuitem">
              <a href="#" target="" title="Pre-Owned">Pre-Owned</a>
            </li>
            <li role="menuitem">
              <a href="#" target="" title="Specials">Specials</a>
            </li>
            <li role="menuitem">
              <a href="#" target="" title="Financing">Financing</a>
            </li>
            <li role="menuitem">
              <a href="#" target="" title="Service &amp; Parts">Service &amp; Parts</a>
            </li>
            <li role="menuitem">
              <a href="#" target="" title="About">About</a>
            </li>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="vehicle-disclaimer">
            <p class="footer-disclaimer">Price does not include licensing costs, registration fees or $799 dealer administration fee. Out-of-state buyers are responsible for taxes and registration fees in their home state. Prices reflect all Ford rebates and incentives available to all purchasers. Additional incentives may be available for qualified buyers. Vehicle inventory and offers are updated frequently but may be subject to prior sale or change without notice. Some vehicles may be in transit—please confirm availability with the dealer. We make every effort to ensure accurate listings but are not responsible for errors or omissions. CONSENT TO CONTACT By submitting your contact information, you agree to be contacted by phone regarding vehicle purchases or financing. Clicking "Submit" serves as your electronic signature. You may withdraw consent by visiting the link to our privacy policy and request to be removed by submitting a personal data request.</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="footer-social">
            <a aria-label="Facebook" class="social-media-link" href="#"><i aria-hidden="true" class="fa fa-facebook"></i></a>
            <a aria-label="Instagram" class="social-media-link" href="#"><i aria-hidden="true" class="fa fa-instagram"></i></a>
            <a aria-label="Twitter" class="social-media-link" href="#"><i aria-hidden="true" class="fa fa-twitter"></i></a>
            <a aria-label="Yelp" class="social-media-link" href="#"><i aria-hidden="true" class="fa fa-yelp"></i></a>
          </div>
        </div>
      </div>
      <div class="footer-line-divide"></div>
      <div class="row footer-bottom">
        <div class="col-md-3 col-xs-12">
          <a href="#">
            <svg xmlns="http://www.w3.org/2000/svg" width="140" height="26" viewBox="0 0 140 26" fill="none">
              <path d="M10.4734 11.7928C5.20116 10.6663 4.23704 9.43828 4.23704 7.439V7.37304C4.23704 5.2672 6.20587 3.80073 9.02718 3.80073C11.4781 3.80073 13.6042 4.60247 15.71 6.31758L15.9181 6.48503L17.7854 4.00877L17.5926 3.85147C14.9996 1.76593 12.4574 0.87793 9.09822 0.87793C4.43494 0.87793 1.05038 3.70939 1.05038 7.60645V7.67242C1.05038 11.4984 3.33889 13.4876 9.21493 14.7663C14.2283 15.8218 15.1772 17.0751 15.1772 19.0236V19.0896C15.1772 21.3121 13.112 22.8649 10.1486 22.8649C7.18521 22.8649 4.76984 21.9109 2.1921 19.5767L1.9942 19.3991L0 21.7587L0.187749 21.9261C3.13592 24.5597 6.27184 25.7877 10.0471 25.7877C14.9641 25.7877 18.3994 22.9258 18.3994 18.8207V18.7547C18.3994 15.086 16.0297 13.0055 10.4734 11.7978" fill="#066FEF"/>
              <path d="M32.9931 0.746094C29.6492 0.746094 26.493 2.05526 24.0979 4.43511C21.6977 6.82003 20.3784 9.9661 20.3784 13.2999C20.3784 20.3431 25.9196 25.8588 32.9982 25.8588C40.0769 25.8588 45.618 20.3431 45.618 13.2999C45.618 9.9661 44.2936 6.81496 41.8985 4.43511C39.5035 2.05526 36.3422 0.746094 32.9982 0.746094M42.3045 13.305C42.3045 18.5112 38.1283 22.7432 32.9931 22.7432C27.8579 22.7432 23.6818 18.5112 23.6818 13.305C23.6818 10.7729 24.6053 8.41336 26.2849 6.65766C28.0051 4.85628 30.39 3.86679 32.9931 3.86679C35.5962 3.86679 37.9812 4.85628 39.7014 6.65766C41.381 8.41336 42.3045 10.7729 42.3045 13.305Z" fill="#066FEF"/>
              <path d="M67.9853 25.1838L57.0096 13.3606L68.234 1.21276H63.7584L52.1484 13.1881L63.6417 25.2751L63.7178 25.3563H67.9092H71.4714L74.1811 19.3991H84.8625L87.5721 25.3563H91.1343L79.5192 0L67.9853 25.1838ZM75.5613 16.3443L79.5192 7.33744L83.4772 16.3443H75.5613Z" fill="#066FEF"/>
              <path d="M96.6854 22.3011V1.25293H93.377V25.3559H107.047V22.3011H96.6854Z" fill="#066FEF"/>
              <path d="M52.1336 1.16699H48.5156V25.3308H52.1336V1.16699Z" fill="#066FEF"/>
              <path d="M122.925 1.25879H130.14L140 13.2443L130.14 25.2349H122.925L132.815 13.2443L122.925 1.25879Z" fill="#066FEF"/>
              <path d="M110.188 1.25879H117.409L127.269 13.2443L117.409 25.2349H110.188L120.083 13.2443L110.188 1.25879Z" fill="#066FEF"/>
            </svg>
          </a>
          <span class="copyright"><a href="#">© </a>{{ new Date().getFullYear() }}</span>
        </div>
        <div class="col-md-9 col-xs-12 text-right">
          <div class="footer-site-links">
            <a class="toggle-sitemap" href="#">Site Map</a>
            <a href="#">Privacy Policy</a>
            <a href="#">Accessibility Policy</a>
            <a href="#">Legal Disclaimer</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  
export default {
  computed: {
  },
  mounted() {
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style lang="scss" scoped>
  @import '@/assets/styles/sokal-utility-classes.scss';
  @import '@/assets/styles/sokal-modern-styles.scss';
  @import '@/assets/styles/modern-utility-classes.scss';
  @import '@/assets/styles/sokal_utility_classes_responsive.scss';
</style>

<style scoped>
.FooterGreyLeft {
  background: #ffffff;
  color: var(--primary-dark);
  font-size: 15px;
  margin-top: 2px;
  padding-bottom: 4%;
}
.FooterGreyLeft[data-theme="infiniti"] {
  background: var(--primary-color, #020B24);
}
.FooterGreyLeft a {
  text-decoration: none;
  color: #999;
  -moz-transition: all 300ms ease-out;
  -webkit-transition: all 300ms ease-out;
  -o-transition: all 300ms ease-out;
  transition: all 300ms ease-out;
}
.FooterGreyLeft a:hover, .FooterGreyLeft a:focus, .FooterGreyLeft a:active {
  opacity: .7;
}
.FooterGreyLeftMenu {
  list-style: none;
  margin-bottom: 15px;
}
.FooterGreyLeftMenu li {
  display: inline-block;
  margin-bottom: 10px;
}
.FooterGreyLeftMenu a {
  color: #fff;
}
.FooterGreyLeft h3 {
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 24px;
  margin-bottom: 0px;
}
.FooterGreyLeft .footer-line-divide {
  height: 2px;
  width: 100%;
  background: #E5E5E5;
}
.FooterGreyLeft .footer-line-divide, .FooterGreyLeft .row {
  margin-top: 30px;
  margin-bottom: 30px;
}
.FooterGreyLeftMenu li:not(:last-child) {
  margin-right: 20px;
}
.FooterGreyLeft .footer-contact {
  margin-top: 30px;
}
.FooterGreyLeft .footer-contact .footer-phones a:not(:last-child) {
  padding-right: 15px;
  border-right: 1px solid #999;
  margin-right: 15px;
}
.FooterGreyLeft .footer-contact .footer-address {
  margin-top: 10px;
}
.FooterGreyLeft .footer-social a:not(:last-child) {
  margin-right: 15px;
}
.FooterGreyLeft .footer-social i {
  font-size: 24px;
}
.FooterGreyLeft .footer-bottom {
  font-size: 13px;
  margin-top: 45px;
}
.FooterGreyLeft .sokal-white-logo {
  height: 22px;
  margin: 0px 20px 0px 0px;
  opacity: .5;
}
.FooterGreyLeft .copyright {
  color: #999;
}
.FooterGreyLeft .footer-bottom .footer-site-links a:not(:last-child) {
  margin-right: 20px;
}

@media (max-width: 991px) {
  .FooterGreyLeft .footer-bottom .col-md-3 {
    margin-bottom: 20px;
  }
  .FooterGreyLeft .footer-bottom .text-right {
    text-align: left;
  }
}
@media (max-width: 767px) {
  .FooterGreyLeft .footer-contact .footer-address {
    display: block;
    margin-top: 15px;
  }
}
@media (max-width: 575px) {
  .FooterGreyLeft {
    font-size: 14px;
  }
  .FooterGreyLeft .footer-bottom .footer-site-links a {
    display: block;
    margin: 10px 0px;
  }
}
</style>

<style scoped>
  .FooterGreyLeft .container {
    max-width: 1500px;
    width: 100%;
    padding-left: 2em;
    padding-right: 2em;
    padding-top: 0;
    margin-left: auto;
    margin-right: auto;
  }
  .FooterGreyLeft .row:first-child {
    margin: 0;
  }
  .FooterGreyLeft .row:nth-child(3) {
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .FooterGreyLeft .FooterGreyLeftMenu a,
  .FooterGreyLeft .footer-bottom .col-md-3.col-xs-12 .copyright,
  .FooterGreyLeft .footer-bottom .col-md-3.col-xs-12 .copyright a,
  .FooterGreyLeft .footer-bottom .col-md-9.col-xs-12.text-right .footer-site-links a {
    color: var(--primary-dark);
    font-family: "FordF1-Semibold";
    text-transform: capitalize;
    font-size: 1rem;
  }
  .FooterGreyLeft .footer-bottom .col-md-3.col-xs-12 .copyright a {
    letter-spacing: -1px;
  }
  .FooterGreyLeft .vehicle-disclaimer {
    font-size: 1rem;
    font-style: normal;
  }
  .FooterGreyLeft .footer-disclaimer {
    color: var(--primary-dark);
    opacity: 0.6;
  }
  .FooterGreyLeft .footer-social a {
    color: var(--secondary-color);
  }
  .FooterGreyLeft .footer-social i {
    font-size: 2rem;
  }
  .FooterGreyLeft .footer-bottom .col-md-3.col-xs-12 {
    display: flex;
    align-items: center;
    column-gap: 15px;
  }
  .footer-dealer-name-add-on .sokal-container {
    padding-left: 2em;
    padding-right: 2em;
  }
  .footer-dealer-name-add-on .dealer-name {
    margin: 0;
  }
  .footer-dealer-name-add-on .contact-cta-block {
    --sokal-gap-value: 10px;
  }
  .footer-dealer-name-add-on .add-on-contact-btn {
    padding: 10px 12px;
    border-radius: 10px;
    border: 2px solid #E5E5E5;
    background: #F0F0F0;
  }
  .footer-dealer-name-add-on .add-on-contact-btn:hover,
  .footer-dealer-name-add-on .add-on-contact-btn:focus,
  .footer-dealer-name-add-on .add-on-contact-btn:active {
    opacity: 0.9;
    text-decoration: none;
  }

  .footer-dealer-name-add-on .add-on-contact-btn-text {
      color: var(--primary-dark);
      font-family: var(--bold-text);
  }
  @media (max-width: 575px) {
    .FooterGreyLeft .FooterGreyLeftMenu {
      display: flex;
      flex-wrap: wrap;
      row-gap: 15px;
    }
    .FooterGreyLeft .FooterGreyLeftMenu li {
      width: 50%;
      margin-right: 0;
    }
    .FooterGreyLeft .footer-bottom .col-md-3.col-xs-12 {
      align-items: start;
      flex-direction: column;
      row-gap: 15px;
    }
    .FooterGreyLeft .footer-bottom .col-md-3 {
      margin-bottom: 0;
    }
  }
</style>